import _ from "lodash";

/*
  Step Sample
  {
    name: 'step-name',
    label: 'Step Label',
    icon: 'step-icon',
    fields: 1,
    active: false
  }
*/

const state = {
  steps: []
};

const getters = {
  steps: state => state.steps,
  current: state => _.find(state.steps, "active"),
  currentIndex: state => _.findIndex(state.steps, "active")
};

const actions = {
  set({ commit }, steps) {
    commit("SET", steps);
  },

  reset({ commit }) {
    commit("RESET");
  },

  next({ commit }) {
    commit("NEXT");
  },

  back({ commit }) {
    commit("BACK");
  },

  goTo({ commit }, name) {
    commit("GOTO", name);
  }
};

const mutations = {
  ["SET"](state, steps) {
    state.steps = steps;
  },

  ["RESET"](state) {
    state.steps = [];
  },

  ["NEXT"](state) {
    let currentStepIndex = _.findIndex(state.steps, "active");

    if (currentStepIndex >= 0) {
      state.steps[currentStepIndex].active = false;
      state.steps[currentStepIndex + 1].active = true;
    }
  },

  ["BACK"](state) {
    let currentStepIndex = _.findIndex(state.steps, "active");

    if (currentStepIndex > 0) {
      state.steps[currentStepIndex].active = false;
      state.steps[currentStepIndex - 1].active = true;
    }
  },

  ["GOTO"](state, name) {
    let currentStepIndex = _.findIndex(state.steps, "active");

    if (currentStepIndex >= 0) {
      state.steps[currentStepIndex].active = false;
    }

    let targetStep = _.findIndex(state.steps, ["name", name]);
    if (targetStep >= 0) {
      state.steps[targetStep].active = true;
    }
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
